import React, { useMemo, useState } from 'react';
import { Link, Redirect, Route, Switch, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { AppBar, Icon, IconButton, Menu, MenuItem, Toolbar } from '@material-ui/core';
import { EntityEditor } from '@sierralabs/entity-ui';
import { QueryEditor, useQueryContext } from '@sierralabs/query-ui';
import { useLogout, UserProfile, useUserContext } from '@sierralabs/user-ui';
import { WorkflowEditor } from '@sierralabs/workflow-ui';
import PlatformMenuButton from './common/platform-menu-button/PlatformMenuButton';
import SiteEditor from './editor/SiteEditor';
import SiteEditorControls from './editor/SiteEditorControls';
import GroupAdmin from './groups/GroupAdmin';
import ReportDetailPage from './reports/ReportDetailPage';
import ReportListPage from './reports/ReportListPage';
import SiteList from './site-list/SiteList';
import SiteListControls from './site-list/SiteListControls';
import { useSiteContext } from './SiteContext';
import { FormEditor } from '@sierralabs/forms-ui';
const StyledDiv = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  .editor-container {
    flex: 1;
  }
  .config-pane,
  .navigation-pane {
    min-width: 240px;
  }
  .site-pane {
    overflow: hidden;
  }
  .route-component-pane {
    overflow: hidden;
  }
  .preview-frame {
    width: 100%;
    height: 100%;
  }
  .flex {
    flex: 1;
  }
`;
const SiteAdminPage = () => {
    const history = useHistory();
    const { user } = useUserContext();
    const { queryBuilderPlugins } = useQueryContext();
    const { editorPath, formElementPlugins } = useSiteContext();
    const { doLogout } = useLogout();
    const [profileMenuAnchor, setProfileMenuAnchor] = useState(null);
    // get path after `editorPath`
    const editorPathArray = editorPath.split('/');
    const menuPath = useMemo(() => history.location.pathname.split('/')[editorPathArray.length - 1], [editorPathArray.length, history.location.pathname]);
    // check permissions
    if (!user) {
        return React.createElement(Redirect, { to: `${editorPath}login` });
    }
    else if (!(user === null || user === void 0 ? void 0 : user.isPasswordSet) &&
        !history.location.pathname.includes(`${editorPath}setup`)) {
        // The user's password is not set, so setup the user
        return React.createElement(Redirect, { to: `${editorPath}setup` });
    }
    else if (history.location.pathname.replace(/\//g, '') === 'admin') {
        // if navigating to /portal, redirect to customers section for admins
        return React.createElement(Redirect, { to: `${editorPath}sites` });
    }
    return (React.createElement(StyledDiv, { className: 'site-admin-page' },
        React.createElement(AppBar, { position: 'static' },
            React.createElement(Toolbar, null,
                React.createElement(PlatformMenuButton, { value: menuPath || 'sites', onChange: value => history.push(`${editorPath}${value}`) }),
                React.createElement(Switch, null,
                    React.createElement(Route, { exact: true, path: `${editorPath}sites`, component: SiteListControls }),
                    React.createElement(Route, { exact: true, path: `${editorPath}sites/:siteId`, component: SiteEditorControls }),
                    React.createElement(Route, null,
                        React.createElement(IconButton, { component: Link, color: 'inherit', to: '.' },
                            React.createElement(Icon, null, "home")),
                        React.createElement("div", { className: 'flex' }))),
                React.createElement(IconButton, { color: 'inherit', onClick: e => setProfileMenuAnchor(e.currentTarget) },
                    React.createElement(Icon, null, "account_circle")),
                React.createElement(Menu, { id: 'profile-menu', anchorEl: profileMenuAnchor, keepMounted: true, open: Boolean(profileMenuAnchor), onClose: e => setProfileMenuAnchor(null) },
                    React.createElement(MenuItem, { onClick: () => {
                            setProfileMenuAnchor(null);
                            history.push(`${editorPath}user-profile`);
                        } }, "Profile"),
                    React.createElement(MenuItem, { onClick: () => {
                            setProfileMenuAnchor(null);
                            doLogout();
                        } }, "Logout")))),
        React.createElement(Switch, null,
            React.createElement(Route, { path: `${editorPath}entities` },
                React.createElement(EntityEditor, { allowVersioning: true, allowWorkflow: true })),
            React.createElement(Route, { path: `${editorPath}workflows`, component: WorkflowEditor }),
            React.createElement(Route, { path: `${editorPath}queries`, component: QueryEditor }),
            React.createElement(Route, { path: `${editorPath}forms` },
                React.createElement(FormEditor, { elementPlugins: formElementPlugins })),
            React.createElement(Route, { exact: true, path: `${editorPath}sites`, component: SiteList }),
            React.createElement(Route, { exact: true, path: `${editorPath}sites/:siteId`, component: SiteEditor }),
            React.createElement(Route, { exact: true, path: `${editorPath}user-profile`, component: UserProfile }),
            React.createElement(Route, { exact: true, path: `${editorPath}groups`, component: GroupAdmin }),
            React.createElement(Route, { exact: true, path: `${editorPath}reports`, component: ReportListPage }),
            React.createElement(Route, { exact: true, path: `${editorPath}reports/:reportId` },
                React.createElement(ReportDetailPage, { queryBuilderPlugins: queryBuilderPlugins })))));
};
export default SiteAdminPage;
//# sourceMappingURL=SiteAdminPage.js.map